import Vue from 'vue'
import Router from 'vue-router'
import { firstMenu } from './privileges'

Vue.use(Router)
export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: () => import('@/views/auth/Login'),
    },
    {
      title: "跳转提示页",
      name: 'tip',
      path: '/tip',
      component: () => import('@/views/business/appRedirectPage/tips'),
    },
    {
      path: '/error',
      component: () => import('@/components/error/index'),
    },
      {
          path: '/',
          component: () => import('@/layout/TagPage'),
          redirect: firstMenu,
          meta: {
              requiresAuth: true,
          },
          children: [
              
              {
                title:'章节添加',
                name: 'course_lesson_add',
                path: '/business/course_lesson_add',
                component: () => import('@/views/business/course_lesson_add'),
              },
              {
                title:'理论题添加',
                name: 'course_homework-bank-theory-add',
                path: '/business/course_homework-bank-theory-add',
                component: () => import('@/views/business/course_homework-bank-theory-add'),
              },
              {
                title:'实操题添加',
                name: 'course_homework-bank-practice-add',
                path: '/business/course_homework-bank-practice-add',
                component: () => import('@/views/business/course_homework-bank-practice-add'),
              },
              {
                title:'理论题详情',
                name: 'course_homework-bank-theory-detail',
                path: '/business/course_homework-bank-theory-detail',
                component: () => import('@/views/business/course_homework-bank-theory-detail'),
              },
              {
                title:'实操题详情',
                name: 'course_homework-bank-practice-detail',
                path: '/business/course_homework-bank-practice-detail',
                component: () => import('@/views/business/course_homework-bank-practice-detail'),
              },
              {
                title:'理论题添加',
                name: 'test-paper-bank-theory-add',
                path: '/business/test-paper-bank-theory-add',
                component: () => import('@/views/business/test-paper-bank-theory-add'),
              },
              {
                title:'实操题添加',
                name: 'test-paper-bank-practice-add',
                path: '/business/test-paper-bank-practice-add',
                component: () => import('@/views/business/test-paper-bank-practice-add'),
              },
              {
                title:'理论题添加',
                name: 'test-paper-bank-theory-detail',
                path: '/business/test-paper-bank-theory-detail',
                component: () => import('@/views/business/test-paper-bank-theory-detail'),
              },
              {
                title:'实操题添加',
                name: 'test-paper-bank-practice-detail',
                path: '/business/test-paper-bank-practice-detail',
                component: () => import('@/views/business/test-paper-bank-practice-detail'),
              },
              {
                title:'试题批阅',
                name: 'course_homework-review-theory-add',
                path: '/business/course_homework-review-theory-add',
                component: () => import('@/views/business/course_homework-review-theory-add'),
              },
              {
                title:'试题批阅',
                name: 'course_homework-review-practice-add',
                path: '/business/course_homework-review-practice-add',
                component: () => import('@/views/business/course_homework-review-practice-add'),
              },
              {
                title:'试题批阅',
                name: 'test-paper-review-theory-add',
                path: '/business/test-paper-review-theory-add',
                component: () => import('@/views/business/test-paper-review-theory-add'),
              },
              {
                title:'试题批阅',
                name: 'test-paper-review-practice-add',
                path: '/business/test-paper-review-practice-add',
                component: () => import('@/views/business/test-paper-review-practice-add'),
              },
          ]
      },
    {
      path: '/',
      component: () => import('@/layout/SinglePage'),
      redirect: firstMenu,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          title:'组件一览',
          name: 'components',
          path: '/components',
          component: () => import('@/views2/sample/Components'),
        },
        {
          name: 'tab',
          path: 'tab',
          component: () => import('@/views2/sample/Tab'),
        },
        {
          title:'统计报表',
          name: 'dashboard',
          path: '/business/dashboard',
          component: () => import('@/views/business/dashboard'),
        },
        {
          title:'课程管理',
          name: 'course-management',
          path: '/business/course-management',
          component: () => import('@/views/business/course-management'),
        },
        {
          title:'课程添加',
          name: 'course-management-add',
          path: '/business/course-management-add',
          component: () => import('@/views/business/course-management-add'),
        },
        {
          title:'考试管理',
          name: 'test-paper-release',
          path: '/business/test-paper-release',
          component: () => import('@/views/business/test-paper-release'),
        },
        {
          title:'教学团队',
          name: 'teach-team',
          path: '/business/teach-team',
          component: () => import('@/views/business/teach-team'),
        },
        {
          title:'章节',
          name: 'course-lesson',
          path: '/business/course_lesson',
          component: () => import('@/views/business/course_lesson'),
        },
        {
          title:'教师详情',
          name: 'teach-team-detail',
          path: '/business/teach-team-detail',
          component: () => import('@/views/business/teach-team-detail'),
        },
        {
          title:'课程',
          name: 'course-management-detail',
          path: '/business/course-management-detail',
          component: () => import('@/views/business/course-management-detail'),
        },
        {
          title:'班级管理',
          name: 'class-management',
          path: '/business/class-management',
          component: () => import('@/views/business/class-management'),
        },
        {
          title:'班级添加',
          name: 'class-management-add',
          path: '/business/class-management-add',
          component: () => import('@/views/business/class-management-add'),
        },
        {
          title:'班级详情',
          name: 'class-management-detail',
          path: '/business/class-management-detail',
          component: () => import('@/views/business/class-management-detail'),
        },
        {
          title:'课程详情',
          name: 'class-management-course',
          path: '/business/class-management-course',
          component: () => import('@/views/business/class-management-course'),
        },
        {
          title:'班级详情',
          name: 'class-management-public',
          path: '/business/class-management-public',
          component: () => import('@/views/business/class-management-public'),
        },
        {
          title: '专业管理',
          name: 'major-management',
          path: '/business/major-management',
          component: () => import('@/views/business/major-management'),
        },
        {
          title:'账号添加',
          name: 'account-add',
          path: '/business/account-add',
          component: () => import('@/views/business/account-add'),
        },
        {
          title:'角色管理',
          name: 'role-management',
          path: '/business/role-management',
          component: () => import('@/views/business/role-management'),
        },
        {
          title:'角色添加',
          name: 'role-add',
          path: '/business/role-add',
          component: () => import('@/views/business/role-add'),
        },
        {
          title:'学员管理',
          name: 'student-management',
          path: '/business/student-management',
          component: () => import('@/views/business/student-management'),
        },
      
        {
          title:'学员管理',
          name: 'course_student-management',
          path: '/business/course_student-management',
          component: () => import('@/views/business/course_student-management'),
        },
        {
          title:'学员清单',
          name: 'display_student_list',
          path: '/business/display_student_list',
          component: () => import('@/views/business/display_student_list'),
        },
        {
          title:'学员学习详情',
          name: 'display_student_list_detail',
          path: '/business/display_student_list_detail',
          component: () => import('@/views/business/display_student_list_detail'),
        },
        {
          title:'学员添加',
          name: 'student-add',
          path: '/business/student-add',
          component: () => import('@/views/business/student-add'),
        },
        {
          title:'学员详情',
          name: 'student-detail',
          path: '/business/student-detail',
          component: () => import('@/views/business/student-detail'),
        },
        {
          title:'作业',
          name: 'course_homework-release',
          path: '/business/course_homework-release',
          component: () => import('@/views/business/course_homework-release'),
        },
        {
          title:"作业库",
          name: 'course_homework-bank',
          path: '/business/course_homework-bank',
          component: () => import('@/views/business/course_homework-bank'),
        },
        {
          title:'资料管理',
          name: 'course_file',
          path: '/business/course_file',
          component: () => import('@/views/business/course_file'),
        },
        {
          title:'章节管理',
          name: 'course_lesson',
          path: '/business/course_lesson',
          component: () => import('@/views/business/course_lesson'),
        },
        {
          title:'班级管理',
          name: 'course_class',
          path: '/business/course_class',
          component: () => import('@/views/business/course_class'),
        },
        {
          name: 'course-homework-detail',
          path: '/business/course-homework-detail',
          component: () => import('@/views/business/course-homework-detail'),
        },
        {
          name: 'course_homework-review',
          path: '/business/course_homework-review',
          component: () => import('@/views/business/course_homework-review'),
        },
        {
          title:'课程详情',
          name: 'course-management-public',
          path: '/business/course-management-public',
          component: () => import('@/views/business/course-management-public'),
        },
        {
          title:'权限管理',
          name: 'permission-management-public',
          path: '/business/permission-management-public',
          component: () => import('@/views/business/permission-management-public'),
        },
        {
          title:"发布作业",
          name: 'course_homework-release-add',
          path: '/business/course_homework-release-add',
          component: () => import('@/views/business/course_homework-release-add'),
        },
        {
          title:'试题库管理',
          name: 'test-paper-bank',
          path: '/business/test-paper-bank',
          component: () => import('@/views/business/test-paper-bank'),
        },
        {
          title:'试题库发布',
          name: 'test-paper-release-add',
          path: '/business/test-paper-release-add',
          component: () => import('@/views/business/test-paper-release-add'),
        },
        {
          title:'试题批阅管理',
          name: 'test-paper-review',
          path: '/business/test-paper-review',
          component: () => import('@/views/business/test-paper-review'),
        },
        {
          title: "实况",
          name: 'course_class_actual',
          path: '/business/course_class_actual',
          component: () => import('@/views/business/course_class_actual'),
        },
        {
          title: "标题2",
          name: 'course_class_test',
          path: '/business/course_class_test',
          component: () => import('@/views/business/course_class_test'),
        },
        {
          title: "手动添加",
          name: 'class-student-add',
          path: '/business/class-student-add',
          component: () => import('@/views/business/class-student-add'),
        },
        {
          title: "批量导入",
          name: 'student-add-import',
          path: '/business/student-add-import',
          component: () => import('@/views/business/student-add-import'),
        },
        {
          title: "APP更新管理",
          name: 'app-version-management',
          path: '/system/app-version-management',
          component: () => import('@/views/system/app-version-management'),
        },
        {
          title: "APP更新添加",
          name: 'app-version-add',
          path: '/system/app-version-add',
          component: () => import('@/views/system/app-version-add'),
        },
        {
          title: "画面添加",
          name: 'page-management-add',
          path: '/system/page-management-add',
          component: () => import('@/views/system/page-management-add'),
        },
        {
          title: "画面管理",
          name: 'page-management',
          path: '/system/page-management',
          component: () => import('@/views/system/page-management'),
        },
        {
          title: "画面详情",
          name: 'page-management-detail',
          path: '/system/page-management-detail',
          component: () => import('@/views/system/page-management-detail'),
        },
        {
          title: "画面API添加",
          name: 'page-management-detail-add',
          path: '/system/page-management-detail-add',
          component: () => import('@/views/system/page-management-detail-add'),
        },
        {
          title: "机构管理",
          name: 'organization-management',
          path: '/system/organization-management',
          component: () => import('@/views/system/organization-management'),
        },
        {
          title: "机构添加",
          name: 'organization-management-add',
          path: '/system/organization-management-add',
          component: () => import('@/views/system/organization-management-add'),
        },
        {
          title: "系统账号管理",
          name: 'administrarors-management',
          path: '/system/administrarors-management',
          component: () => import('@/views/system/administrarors-management'),
        },
        {
          title: "机构账号添加",
          name: 'administrarors-add',
          path: '/system/administrarors-add',
          component: () => import('@/views/system/administrarors-add'),
        },
        {
          title: "操作日志",
          name: 'operation-log-public',
          path: '/business/operation-log-public',
          component: () => import('@/views/business/operation-log-public'),
        },
        {
          title: "操作日志",
          name: 'operation-log-management',
          path: '/business/operation-log-management',
          component: () => import('@/views/business/operation-log-management'),
        },
        {
          title: "登录日志",
          name: 'login-log-management',
          path: '/business/login-log-management',
          component: () => import('@/views/business/login-log-management'),
        },
        {
          title: "消息通知",
          name: 'message-management',
          path: '/business/message-management',
          component: () => import('@/views/business/message-management'),
        },
        {
          title: "消息添加",
          name: 'message-add',
          path: '/business/message-add',
          component: () => import('@/views/business/message-add'),
        },
        {
          title: "专业清单",
          name: "display-major-list",
          path: "/business/display-major-list",
          component: () => import("@/views/business/display-major-list"),
        },         
        {
          title:'班级清单',
          name: 'display-class-list',
          path: '/business/display-class-list',
          component: () => import('@/views/business/display-class-list'),
        },
        {
          title:'课程清单',
          name: 'display-course-list',
          path: '/business/display-course-list',
          component: () => import('@/views/business/display-course-list'),
        },
        {
          title:'章节清单',
          name: 'display-lesson-list',
          path: '/business/display-lesson-list',
          component: () => import('@/views/business/display-lesson-list'),
        },
        {
          title:'章节学习清单',
          name: 'display-lesson-list-detail',
          path: '/business/display-lesson-list-detail',
          component: () => import('@/views/business/display-lesson-list-detail'),
        },
        {
          title:'签到管理',
          name: 'class_student_sign_list',
          path: '/business/class_student_sign_list',
          component: () => import('@/views/business/class_student_sign_list'),
        },
        {
          title: "数据统计",
          name: 'video_data_total',
          path: '/system/video_data_total',
          component: () => import('@/views/system/video_data_total'),
        },
        {
          title: "登录统计",
          name: 'login_in_count_list',
          path: '/system/login_in_count_list',
          component: () => import('@/views/system/login_in_count_list'),
        },
        {
          title: "学员管理",
          name: 'adm_student_list',
          path: '/system/adm_student_list',
          component: () => import('@/views/system/adm_student_list'),
        },
        {
          title: "学员详情",
          name: 'adm_class-student-detail',
          path: '/system/adm_class-student-detail',
          component: () => import('@/views/system/adm_class-student-detail'),
        },
        {
          title: "学习记录详情",
          name: 'adm-lesson-management-detail',
          path: '/system/adm-lesson-management-detail',
          component: () => import('@/views/system/adm-lesson-management-detail'),
        },
        {
          title: "统计详情",
          name: 'video_data_list',
          path: '/system/video_data_list',
          component: () => import('@/views/system/video_data_list'),
        },
        {
          title: "学生详情",
          name: 'student_data_list',
          path: '/system/student_data_list',
          component: () => import('@/views/system/student_data_list'),
        },
        {
          title:'学员首页',
          name: 'stu-dashboard',
          path: '/student/stu-dashboard',
          component: () => import('@/views/student/stu-dashboard'),
        },
        {
          title:'学员证明',
          name: 'stu-graduation-prove',
          path: '/student/stu-graduation-prove',
          component: () => import('@/views/student/stu-graduation-prove'),
        },
        {
          title:'章节管理',
          name: 'stu-lesson-management',
          path: '/student/stu-lesson-management',
          component: () => import('@/views/student/stu-lesson-management'),
        },
        {
          title:'章节详情',
          name: 'stu-lesson-management-detail',
          path: '/student/stu-lesson-management-detail',
          component: () => import('@/views/student/stu-lesson-management-detail'),
        },
        {
          title:'资料管理',
          name: 'stu-file-management',
          path: '/student/stu-file-management',
          component: () => import('@/views/student/stu-file-management'),
        },
        {
          title:'作业管理',
          name: 'stu-homework-management',
          path: '/student/stu-homework-management',
          component: () => import('@/views/student/stu-homework-management'),
        },
        {
          title:'作业试题详情',
          name: 'stu-homework-theory-detail',
          path: '/student/stu-homework-theory-detail',
          component: () => import('@/views/student/stu-homework-theory-detail'),
        },
        {
          title:'作业试题编辑',
          name: 'stu-homework-theory-edit',
          path: '/student/stu-homework-theory-edit',
          component: () => import('@/views/student/stu-homework-theory-edit'),
        },
        {
          title:'作业试题详情',
          name: 'stu-homework-practice-detail',
          path: '/student/stu-homework-practice-detail',
          component: () => import('@/views/student/stu-homework-practice-detail'),
        },
        {
          title:'作业试题编辑',
          name: 'stu-homework-practice-edit',
          path: '/student/stu-homework-practice-edit',
          component: () => import('@/views/student/stu-homework-practice-edit'),
        },
        {
          title:'考试管理',
          name: 'stu-test-management',
          path: '/student/stu-test-management',
          component: () => import('@/views/student/stu-test-management'),
        },
        {
          title:'实况',
          name: 'class-management_actual',
          path: '/business/class-management_actual',
          component: () => import('@/views/business/class-management_actual'),
        },
        {
          title:'作业',
          name: 'class-homework-paper-release',
          path: '/business/class-homework-paper-release',
          component: () => import('@/views/business/class-homework-paper-release'),
        },
        {
          title:'obs废弃文件清理',
          name: 'abandon-clean',
          path: '/business/abandon-clean',
          component: () => import('@/views/business/abandon-clean'),
        },
      ]
    },
  ],
})
